import React, { useState, useEffect } from 'react';
import { Globals } from '../../../../utils';
import axios from '../../../../utils/axios';
import { Table, Pagination, Button, Icon } from '../../../../components';
import moment from 'moment';
import ModalProductPromoted from './ModalProductPromoted';
import ModalViewProductsPromoted from './ModalViewProductsPromoted';

const ProductsPromotedList = ({ user_id }) => {
    const [data, setData] = useState([]);
    const [page, setPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [showModal, setShowModal] = useState(false);
    const [showViewModal, setShowViewModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);

    const loadData = async (currentPage = 1) => {
        Globals.setLoading();
        try {
            const res = await axios.post(`admin/inventory/products-promoted/list?page=${currentPage}`, {
                user_id
            });
            if (res.data.result) {
                setData(res.data.data.data);
                setPage(res.data.data.current_page);
                setLastPage(res.data.data.last_page);
            }
        } catch (error) {
            console.error('ProductsPromotedList -> loadData:', error);
        }
        Globals.quitLoading();
    };

    useEffect(() => {
        if (user_id) {
            loadData(page);
        }
    }, [user_id]);

    const deleteItem = (id) => {
        Globals.confirm('La eliminación causará que deje de aplicarse en la App inmediatamente. ¿Desea continuar?', () => {
            Globals.setLoading("Eliminando...");
            axios.post('admin/inventory/products-promoted/delete', { id })
                .then(res => {
                    if (res.data.result) {
                        Globals.showSuccess('Registro eliminado exitosamente');
                        loadData(page);
                    } else {
                        Globals.showError(res.data.message || 'Error al eliminar');
                    }
                })
                .catch(err => {
                    console.error(err);
                    Globals.showError('Ocurrió un error inesperado al eliminar');
                })
                .finally(() => {
                    Globals.quitLoading();
                });
        });
    };

    return (
        <div style={{ marginTop: '40px' }}>
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h3 className="custom-title" style={{ margin: '0' }}>Productos a promover</h3>
                <Button color="primary" onClick={() => { setSelectedItem(null); setShowModal(true); }}>
                    + Agregar nuevo
                </Button>
            </div>

            <div style={{ border: '1px solid #eee', borderRadius: '10px', overflow: 'hidden' }}>
                {data.length > 0 ? (
                    <>
                        <Table
                            header={['Desde (Periodo)', 'Hasta (Periodo)', 'Lista de Productos a promover', 'Acciones']}
                            data={data.length}
                        >
                            {data.map((item, index) => (
                                <tr key={item.id}>
                                    <td>{moment(item.start_date).format('DD-MM-YYYY')}</td>
                                    <td>{moment(item.end_date).format('DD-MM-YYYY')}</td>
                                    <td>
                                        <span
                                            style={{ cursor: 'pointer', background: '#007bff', color: '#fff', padding: '5px 15px', borderRadius: '20px', fontSize: '12px', fontWeight: 'bold' }}
                                            onClick={() => { setSelectedItem(item); setShowViewModal(true); }}
                                        >
                                            Ver
                                        </span>
                                    </td>
                                    <td style={{ textAlign: 'right' }}>
                                        <div className="d-flex justify-content-end align-items-center" style={{ gap: '15px' }}>
                                            <span style={{ cursor: 'pointer', color: '#007bff' }} onClick={() => { setSelectedItem(item); setShowModal(true); }}>
                                                <Icon name="edit" />
                                            </span>
                                            <span style={{ cursor: 'pointer', color: '#dc3545' }} onClick={() => deleteItem(item.id)}>
                                                <Icon name="trash" />
                                            </span>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </Table>
                        <Pagination
                            pages={lastPage}
                            active={page}
                            onChange={p => {
                                setPage(p);
                                loadData(p);
                            }}
                        />
                    </>
                ) : (
                    <div className="alert alert-info m-0">
                        No hay productos a promover registrados
                    </div>
                )}
            </div>

            <ModalProductPromoted
                show={showModal}
                data={selectedItem}
                user_id={user_id}
                onClose={() => setShowModal(false)}
                onSuccess={() => loadData(page)}
            />

            <ModalViewProductsPromoted
                show={showViewModal}
                data={selectedItem}
                onHide={() => setShowViewModal(false)}
            />
        </div>
    );
};

export default ProductsPromotedList;
